// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { Dictionary } from "@insite/client-framework/Common/Types";
import {
    ApiParameter,
    get,
    HasPagingParameters,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import {
    TaxExemptionCertificateCollectionModel,
    TaxExemptionCertificateModel,
    TECFinanceCompanyModel,
    TECMessagesModel,
    TECNotificationModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GetTaxExemptionCertificatesApiParameter extends ApiParameter, HasPagingParameters {}

export interface GetSingleTaxExemptionCertificateApiParameter extends ApiParameter {
    certificateId?: string;
}

export interface GetTECMessagesApiParameter extends ApiParameter {}

export interface GetTECFinanceCompaniesApiParameter extends ApiParameter {}

const tecUrl = "/api/v1/custom/taxexemptioncertificates";

export async function getTaxExemptionCertificates(parameter: GetTaxExemptionCertificatesApiParameter) {
    const taxExemptionCertificates = await get<TaxExemptionCertificateCollectionModel>(tecUrl, parameter);
    return taxExemptionCertificates;
}

export async function getSingleTaxExemptionCertificate(parameter: GetSingleTaxExemptionCertificateApiParameter) {
    const { certificateId, ...newParameter } = parameter;
    const taxExemptionCertificate = await get<TaxExemptionCertificateModel>(`${tecUrl}/${certificateId}`, newParameter);
    return taxExemptionCertificate;
}

export interface TECNotificationApiParameter extends ApiParameter {
    tecNotificationModel: TECNotificationModel;
}

export async function sendTECNotificationEmail(
    parameter: TECNotificationApiParameter,
): Promise<ServiceResult<TECNotificationModel>> {
    try {
        const tecNotificationModel = await post<TECNotificationModel>(`${tecUrl}`, parameter.tecNotificationModel);
        return {
            successful: true,
            result: tecNotificationModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function getTECMessages(parameter: GetTECMessagesApiParameter) {
    const tecMessages = await get<TECMessagesModel>(`${tecUrl}/messages`, parameter);
    return tecMessages;
}

export async function getTECFinanceCompanies(parameter: GetTECFinanceCompaniesApiParameter) {
    const tecFinanceCompanies = await get<TECFinanceCompanyModel>(`${tecUrl}/financecompanies`, parameter);
    return tecFinanceCompanies;
}
